module.exports = __webpack_public_path__ + "static/media/postprod.23fae82f.webp";